import { createBrowserHistory } from "history";

const RouterHistory = createBrowserHistory();

function isRouteMatchingLocation(route: string): boolean {
    return RouterHistory.location.pathname.endsWith(`${route.startsWith("/") ? "" : "/" }${route}`);
}

function getRouteFromLocation(location: Location): string {
    return location.pathname;
}

export { getRouteFromLocation, isRouteMatchingLocation, RouterHistory };
